/*


*/
import { useState } from "react";
import { getENSInfo } from "../util/Api";

export default function UseENS() {
  const [ENSMap, setENSMap] = useState([]);
  const [mutex, setMutex] = useState(false);
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  // Functions to get data from API
  const getENS = async (address) => {
    while (mutex) {
      await sleep(200);
    }
    setMutex(true);
    for (const thisEns of ENSMap){
      if(thisEns.address == address){
        setMutex(false);
        return thisEns.info;
      }
    }
    const ensData = await getENSInfo(address);
    const newList = ENSMap;
    console.log("Fetched ENS data for address " + address);
    newList.push({address: address, info: ensData});
    setENSMap(newList);
    setMutex(false);
    return ensData;
  };

  return {
    ENSMap,
    getENS,
  };
}
